<div class="container dialog-container">

  <h3 i18n class="display-6" align="center" style="padding-top: 10px; color: #005d87; font-weight: bold;">
        Edit Contact Information
    </h3>

  <form [formGroup]="profileForm">

    <div class="row">
      <h6 i18n class="blue-heading">
            Address
            </h6>
      <mat-form-field appearance="fill">
        <mat-label i18n>
                Address
            </mat-label>
        <input matInput
          required
          maxlength="50"
          formControlName="address"
          (input)="sharedMethodsService.forbidWhitespaceOnly('address', profileForm)">
          @if (profileForm.invalid) {
            <mat-error i18n>
                Required
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="row">
        <h6 i18n class="blue-heading">
            City
            </h6>
        <mat-form-field appearance="fill">
          <mat-label i18n>
                City
            </mat-label>
          <input matInput
            required
            maxlength="50"
            formControlName="city"
            (input)="sharedMethodsService.forbidWhitespaceOnly('city', profileForm)">
            @if (profileForm.invalid) {
              <mat-error i18n>
                Required
            </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="row">
          <h6 i18n class="blue-heading">
            Postal Code
            </h6>
          <mat-form-field appearance="fill">
            <mat-label i18n>
                Postal Code
            </mat-label>
            <input matInput
              required
              maxlength="7"
              formControlName="postalCode"
              (input)="sharedMethodsService.forbidWhitespaceOnly('postalCode', profileForm)">
              <mat-error i18n>
              {postalError, select, Invalid format {Invalid format} Required {Required}}
            </mat-error>
            </mat-form-field>
          </div>

          <div class="row">
            <h6 i18n class="blue-heading">
            Phone Number
            </h6>
            <mat-form-field #telField
              appearance="fill">
              <mat-label i18n>
                Phone Number
            </mat-label>
              <app-tel-input #telInput
                formControlName="phoneNum">

              </app-tel-input>
              <mat-icon matSuffix>
                phone
              </mat-icon>
              @if (profileForm.invalid || !phoneValid) {
                <mat-error i18n>
                Required
            </mat-error>
              }
            </mat-form-field>
          </div>

        </form>

        <div class="row bottom-buttons">

          <div class="outer">

            <div class="inner" style="margin-right: 40%">
              <button i18n mat-stroked-button
                type="submit"
                style="background-color: #005d87; color: white; font-weight: bold;"
                (click)="updateContactInfo(false)">
                      Back
                  </button>    
            </div>

            <div class="inner">
              <button i18n mat-stroked-button
                type="submit"
                style="background-color: #ff6f61; color: white; font-weight: bold;"
                align="end"
                (click)="updateContactInfo(true)">
                      Update
                  </button>                
            </div>

          </div>

        </div>

      </div>
